import { gql } from "@apollo/client";

export const listOptions = `
  options: { 
    limit: $limit, page: $page, 
    sort: { updatedAt: DESC },
    filter: { updatedAt: {after: $after} }
    filterOperator: OR
    includeDeleted: true
  }
`;

export const listVariables = `
  $after: DateTime,
  $page: Int,
  $limit: Int
`;

export const productsQuery = gql`
    query GetProducts(${listVariables}) {
        products(${listOptions}) {
            items {
                id
                name
                updatedAt
                createdAt
            }
        }
    }
`;
